class BreadcrumbOverflow {
  constructor(el) {
    this.roots = document.querySelectorAll('.' + el);
    if (!this.roots.length) return;

    this.spQuery = window.matchMedia('(max-width: 767px)');
    this.resizeQueued = false;

    this.items = Array.from(this.roots).map((root) => ({
      root,
      scroller: root.querySelector('.c-breadcrumb__scroller') || root,
    }));

    this.items.forEach((item) => {
      item.scroller.addEventListener(
        'scroll',
        () => this.update(item),
        { passive: true }
      );
    });

    this.spQuery.addEventListener('change', () => this.updateAll());
    window.addEventListener('resize', () => {
      if (this.resizeQueued) return;
      this.resizeQueued = true;
      window.requestAnimationFrame(() => {
        this.resizeQueued = false;
        this.updateAll();
      });
    });

    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.updateAll());
      this.items.forEach((item) => {
        this.observer.observe(item.root);
        this.observer.observe(item.scroller);
      });
    }

    this.updateAll();
  }

  updateAll() {
    this.items.forEach((item) => this.update(item));
  }

  update(item) {
    const { root, scroller } = item;
    const canScroll =
      this.spQuery.matches &&
      scroller.scrollWidth > scroller.clientWidth + 1;

    if (!canScroll) {
      root.classList.remove(
        'is-overflow',
        'is-overflow-start',
        'is-overflow-end'
      );
      return;
    }

    const start = scroller.scrollLeft;
    const max = scroller.scrollWidth - scroller.clientWidth;
    root.classList.add('is-overflow');
    root.classList.toggle('is-overflow-start', start > 1);
    root.classList.toggle('is-overflow-end', start < max - 1);
  }
}
